
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38 13v22a3 3 0 01-3 3H13a3 3 0 01-3-3V13a3 3 0 013-3h22a3 3 0 013 3zm-22.219 8.781l7.688 7.688a.75.75 0 001.062 0l7.688-7.688a.75.75 0 00-.532-1.281H16.313a.75.75 0 00-.53 1.281z","fill":"#535353","fill-rule":"nonzero"}})])
          )
        }
      }
    